import * as yup from "yup";
import { CountryEnum } from "@lib/types/Country";

export const customerSchema = yup.object().shape({
  name: yup.string().required().min(3),
  enabled: yup.bool().required(),
  logoUrl: yup.string().nullable().min(100),
  domain: yup.string().url().nullable(),
  isClosed: yup.bool().required(),
  isAutoBtcEnabled: yup.bool().required(),
  isWhatsappPlatform: yup.bool().required(),
  isMarketPlaceEnabled: yup.bool().required(),
  aiServicesMargin: yup.number().nullable().min(0).max(100),
  email: yup.string().email().nullable(),
  phone: yup.string().nullable(),
  address: yup.string().nullable(),
  country: yup.string().oneOf(Object.values(CountryEnum)).nullable(),
  city: yup.string().nullable(),
  website: yup.string().url().nullable(),
  taxNumber: yup.string().nullable(),
});

export const customerLeadSchema = yup.object().shape({
  firstName: yup.string().required().min(3),
  lastName: yup.string().required().min(3),
  isDisabled: yup.bool().required(),
  customerId: yup.string().required(),
  baseUserId: yup.string().uuid().required(),
});
